<!--
 * @创建文件时间: 2019-12-29 10:34:22
 * @Auther: lfq
 * @最后修改人        : lfq
 * @最后修改时间       : 2020-01-09 10:32:00
 * @联系Qq:1638245306
 * @文件介绍: echart按钮组
 -->
<template>
  <div>
      <el-button-group>
            <el-button @click="changeTable">表格</el-button>
            <el-button @click="change('line')">折线</el-button>
            <el-button @click="change('bar')">柱状</el-button>
      </el-button-group>
      <div>
          <el-dialog  :visible.sync="dialogTableVisible">
            <el-table :data="tableData" border max-height="500">
                <el-table-column property="name" :label="echartsTitle"  header-align="center"></el-table-column>
                <el-table-column property="value" label="个数" align="center"></el-table-column>
            </el-table>
            </el-dialog>
      </div>
  </div>
</template>

<script>
export default {
  name:"btnTools",
  components: {},
  props: {
      echartsTitle: { // 标题
      type: [String, Array, Object],
      deep: true,
      default () {
        return {
          title: ''
        }
      }
    },
      echartsData: {
      type: [Object],
      deep: true,
      default () {
        return {
          yAxisName: '',
          xAxisName: [],
          yAxisDataType: 'date',
          data: []
            }
        }
      }
  },
  data() {
    return {
        dialogTableVisible:false,
        tableData:[]
    };
  },
  watch: {},
  computed: {},
  methods: {
      changeTable(){
          this.dialogTableVisible = true
         
          this.tableData = this.echartsData.data
      },
      change(val){
        this.$emit('change',val)
      }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
</style>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/EchartTools/Tools/btnTools.vue"
}
</vue-filename-injector>
